import { getBeforeRequestParams } from '@pages/distributor/trade/order/audit/search/service';

export default {
  // 获取处理过后的参数
  getSearchParams(state) {
    return getBeforeRequestParams(state);
  },
  // 获取标签 (增加系统且系统标签放在自定义标签前面)
  getTagList(state) {
    const tagList = state.tagList || [];
    const commonTagList = tagList.filter(item => item.type == 0); // 普通标签
    const sysTagList = tagList.filter(item => item.type == 3); // 系统标签
    return [...sysTagList, ...commonTagList];
  },
  getCurrentTabKey(state) {
    return state.currentTab?.key;
  },
  getCurrentTabQueryId(state) {
    const queryId = state.currentTab.queryId;
    return Array.isArray(queryId) ? queryId.join('') : 8; // queryId 默认传8
  },
  getCurrentPagesTotal(state) {
    return state.paginationModel.total;
  },
  // 表格选中数据
  auditMultipleSelection(state) {
    const { checksTable, auditTableData } = state;
    const data = [];
    checksTable.forEach((item, index) => {
      item && data.push(auditTableData[index]);
    });
    return data;
  },
  // 快捷查询
  getGroupList(state) {
    return state.groupList.map(item => {
      const { condition = [], group = {} } = item;
      return {
        id: group?.id || '',
        name: group?.name || '',
        list: condition,
      };
    });
  },
  // 用户店铺
  getShopList(state) {
    return state.dictionaryData.shopList;
  },
  // 选中数据相关数据汇总
  footerBarCheckedValue(state, getters) {
    let paymentSummary = 0; // 应付金额
    let actualPostFeeSummary = 0; // 运费
    let totalCostSummary = 0; // 分销金额
    let fxCommissionSummary = 0; // 佣金
    let fxCostSummary = 0; // 分销总成本
    let grossProfitSummary = 0; // 订单毛利润
    let num = 0; // 订单数
    const selected = getters.auditMultipleSelection || [];

    const toFixedN = RC.tools.toFixedN;
    selected.forEach(tradeData => {
      paymentSummary = toFixedN((+paymentSummary + (tradeData.columnPayment || 0) * 1), 6);
      actualPostFeeSummary = toFixedN((+actualPostFeeSummary + (tradeData.actualPostFee || 0) * 1), 6);
      totalCostSummary = toFixedN((+totalCostSummary + (tradeData.totalCost || 0) * 1), 6);
      fxCommissionSummary = toFixedN((+fxCommissionSummary + (tradeData.fxCommission || 0) * 1), 6);
      fxCostSummary = toFixedN((+fxCostSummary + (tradeData.fxCost || 0) * 1), 6);
      grossProfitSummary = toFixedN((+grossProfitSummary + (tradeData.grossProfit || 0) * 1), 6);
    })
    num = selected.length;

    return {
      num,
      payment: paymentSummary,
      totalCost: totalCostSummary,
      actualPostFee: actualPostFeeSummary,
      fxCommission: fxCommissionSummary,
      fxCost: fxCostSummary,
      grossProfit: grossProfitSummary,
    }
  },
  // 列表商品信息展示设置
  listGoodsShow(state) {
    return state.goodsInfoShow.value;
  },
  goodsInfoList(state) {
    return state.goodsInfoList;
  },
  // 当前页的pageSize
  pageSize(state, getters) {
    const key = getters.getCurrentTabKey;
    const map = state.pageSizeRemote.value;
    const value = map[key] || 50;
    return value;
  },
  needInitRemotePageSize(state) {
    return state.pageSizeRemote.needInit
  },
  // 审核状态数量统计
  auditStatusCount(state) {
    return state.auditStatusCount;
  },
};
